<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="页面目录名称">
          <el-input placeholder="请输入页面目录名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加页面目录</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="name" label="页面目录名称"></el-table-column>
            <el-table-column prop="charge_type_text" label="收费模式" width="120"></el-table-column>
            <el-table-column prop="price_info" label="价格信息" width="150"></el-table-column>
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                    <el-button @click="stageClick(scope.row)" type="text" size="small">阶段</el-button>
                    <el-button @click="chargeModeClick(scope.row)" type="text" size="small">收费模式</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :studymenu_id="studymenu_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <!-- 收费模式设置弹窗 -->
    <el-dialog 
      title="设置收费模式" 
      :visible.sync="chargeModeDialogVisible" 
      @close='closeChargeModeDialog' 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" 
      :append-to-body="true"
      width="600px"
    >
      <el-form ref="chargeForm" :model="chargeForm" :rules="chargeRules" label-width="120px" size="small">
        <el-form-item label="页面目录名称">
          <el-input v-model="currentRow.name" disabled class="max-w400"></el-input>
        </el-form-item>

        <el-form-item label="收费方式" prop="charge_type">
          <el-radio-group v-model="chargeForm.charge_type" @change="handleChargeTypeChange">
            <el-radio :label="1">免费</el-radio>
            <el-radio :label="2">整体付费</el-radio>
            <el-radio :label="3">按章节付费</el-radio>
            <el-radio :label="4">首节体验+整体付费</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 价格设置区域 -->
        <div v-if="chargeForm.charge_type !== 1" class="price-settings">
          <!-- 整体付费价格 -->
          <el-form-item 
            v-if="chargeForm.charge_type === 2" 
            label="目录价格" 
            prop="total_price"
          >
            <el-input 
              v-model="chargeForm.total_price" 
              placeholder="请输入目录价格" 
              class="max-w400"
              type="number"
              min="0"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>

          <!-- 首节体验+整体付费价格 -->
          <div v-if="chargeForm.charge_type === 4" class="multi-price">
            <el-form-item 
              label="首节体验价" 
              prop="first_lesson_price"
            >
              <el-input 
                v-model="chargeForm.first_lesson_price" 
                placeholder="请输入首节体验价格" 
                class="max-w400"
                type="number"
                min="0"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item 
              label="整体目录价" 
              prop="total_price"
            >
              <el-input 
                v-model="chargeForm.total_price" 
                placeholder="请输入整体目录价格" 
                class="max-w400"
                type="number"
                min="0"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>

          <!-- 按章节付费设置 -->
          <div v-if="chargeForm.charge_type === 3" class="chapter-pricing">
              <div class="chapter-price-list">
                <div class="chapter-price-item" v-for="(chapter, index) in chargeForm.chapters" :key="index">
                  <div class="chapter-header">
                    <span class="chapter-title">第{{ index + 1 }}章节</span>
                  </div>
                  <div class="chapter-content">
                    <el-form-item 
                      :label="`章节名称`"
                      :prop="`chapters.${index}.name`"
                      :rules="{ required: true, message: '请输入章节名称', trigger: 'blur' }"
                    >
                      <el-input 
                        v-model="chapter.name" 
                        placeholder="请输入章节名称"
                        class="chapter-input"
                      ></el-input>
                    </el-form-item>
                    <el-form-item 
                      label="章节价格"
                      :prop="`chapters.${index}.price`"
                      :rules="{ required: true, message: '请输入章节价格', trigger: 'blur' }"
                    >
                      <el-input 
                        v-model="chapter.price" 
                        placeholder="请输入章节价格"
                        class="chapter-input"
                        type="number"
                        min="0"
                      >
                        <template slot="append">元</template>
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeChargeModeDialog" size="small">取消</el-button>
        <el-button type="primary" @click="saveChargeMode" :loading="chargeLoading" size="small">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import StudymenuApi from '@/api/studymenu.js';
  import Stage_stageApi from '@/api/stage_stage.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        studymenu_id:"",
        dialogVisible:false,

        // 收费模式弹窗相关
        chargeModeDialogVisible: false,
        chargeLoading: false,
        currentRow: {},
        chargeForm: {
          charge_type: 1,
          total_price: '',
          first_lesson_price: '',
          chapters: [{ name: '', price: '' }]
        },
        chargeRules: {
          charge_type: [{ required: true, message: '请选择收费方式', trigger: 'change' }],
          total_price: [{ required: false, message: '请输入目录价格', trigger: 'blur' }],
          first_lesson_price: [{ required: false, message: '请输入首节体验价格', trigger: 'blur' }]
        },
        // 存储获取到的章节数据
        stageList: []
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//页面目录标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        StudymenuApi.list(Params, true)
          .then(data => {
            self.loading = false;
            // 处理收费模式显示
            const tableData = data.data.list.data.map(item => {
              return {
                ...item,
                charge_type_text: this.getChargeTypeText(item.charge_type),
                price_info: this.getPriceInfo(item)
              };
            });
            self.tableData = tableData;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },

      // 获取收费方式文本
      getChargeTypeText(chargeType) {
        const chargeTypes = {
          1: '免费',
          2: '整体付费',
          3: '按章节付费',
          4: '首节体验+整体付费'
        };
        return chargeTypes[chargeType] || '未设置';
      },

      // 获取价格信息
      getPriceInfo(item) {
        if (item.charge_type === 1) {
          return '免费';
        } else if (item.charge_type === 2) {
          return `¥${item.total_price}`;
        } else if (item.charge_type === 3) {
          const chapterCount = item.chapters ? item.chapters.length : 0;
          return `${chapterCount}个章节`;
        } else if (item.charge_type === 4) {
          return `首节¥${item.first_lesson_price} 整体¥${item.total_price}`;
        }
        return '-';
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.studymenu_id = row.studymenu_id;
        this.open_edit = true
      },

      // 收费模式设置
      chargeModeClick(row) {
        this.currentRow = { ...row };

        // 获取该页面目录下的所有章节
        this.getStageList(row.studymenu_id);
      },

      // 获取章节列表
      getStageList(row,studymenu_id) {
        let self = this;
        let Params = {
          studymenu_id: studymenu_id,
          page: 1,
          list_rows: 100 // 获取所有章节
        };
        
        Stage_stageApi.list(Params, true)
          .then(data => {
            self.stageList = data.data.list.data || [];
            
            // 初始化收费表单数据
            self.initChargeForm(row);
            
            self.chargeModeDialogVisible = true;
          })
          .catch(error => {
            console.error('获取章节列表失败:', error);
            // 即使获取失败也显示弹窗
            self.initChargeForm(row);
            self.chargeModeDialogVisible = true;
          });
      },

      // 初始化收费表单数据
      initChargeForm(row) {
        // 如果有已保存的章节数据，使用已保存的数据
        if (row.chapters && row.chapters.length > 0) {
          this.chargeForm = {
            charge_type: row.charge_type || 1,
            total_price: row.total_price || '',
            first_lesson_price: row.first_lesson_price || '',
            chapters: JSON.parse(JSON.stringify(row.chapters))
          };
        } else {
          // 如果没有已保存的数据，使用从API获取的章节数据
          const chapters = this.stageList.map(stage => ({
            name: stage.name,
            price: stage.price || ''
          }));
          
          // 如果没有获取到章节数据，使用默认值
          if (chapters.length === 0) {
            chapters.push({ name: '', price: '' });
          }
          
          this.chargeForm = {
            charge_type: row.charge_type || 1,
            total_price: row.total_price || '',
            first_lesson_price: row.first_lesson_price || '',
            chapters: chapters
          };
        }
      },

      // 关闭收费模式弹窗
      closeChargeModeDialog() {
        this.chargeModeDialogVisible = false;
        this.currentRow = {};
        this.chargeForm = {
          charge_type: 1,
          total_price: '',
          first_lesson_price: '',
          chapters: [{ name: '', price: '' }]
        };
        this.stageList = [];
      },

      // 收费方式改变处理
      handleChargeTypeChange(value) {
        // 重置相关价格字段
        if (value === 1) {
          // 免费：清空所有价格字段
          this.chargeForm.total_price = '';
          this.chargeForm.first_lesson_price = '';
          this.chargeForm.chapters = [{ name: '', price: '' }];
        } else if (value === 2) {
          // 整体付费：清空章节和首节价格
          this.chargeForm.first_lesson_price = '';
          this.chargeForm.chapters = [{ name: '', price: '' }];
        } else if (value === 3) {
          // 按章节付费：清空整体价格和首节价格
          this.chargeForm.total_price = '';
          this.chargeForm.first_lesson_price = '';
          // 确保至少有一个章节
          if (this.chargeForm.chapters.length === 0) {
            this.chargeForm.chapters = [{ name: '', price: '' }];
          }
        } else if (value === 4) {
          // 首节体验+整体付费：清空章节
          this.chargeForm.chapters = [{ name: '', price: '' }];
        }
      },

      // 添加章节
      addChapter() {
        this.chargeForm.chapters.push({
          name: '',
          price: ''
        });
      },

      // 删除章节
      removeChapter(index) {
        if (this.chargeForm.chapters.length > 1) {
          this.chargeForm.chapters.splice(index, 1);
        } else {
          this.$message.warning('至少需要保留一个章节');
        }
      },

      // 保存收费模式
      saveChargeMode() {
        this.$refs.chargeForm.validate(valid => {
          if (valid) {
            // 验证价格数据
            const priceValid = this.validateChargePriceData();
            if (!priceValid) {
              return;
            }

            this.chargeLoading = true;
            const params = {
              studymenu_id: this.currentRow.studymenu_id,
              ...this.chargeForm
            };

            StudymenuApi.change(params, true)
              .then(data => {
                this.chargeLoading = false;
                this.$message({
                  message: data.msg || '收费模式设置成功',
                  type: 'success'
                });
                this.closeChargeModeDialog();
                this.getTableList();
              })
              .catch(error => {
                this.chargeLoading = false;
                this.$message.error('设置失败: ' + (error.message || '网络错误'));
              });
          }
        });
      },

      // 验证收费价格数据
      validateChargePriceData() {
        const { charge_type, total_price, first_lesson_price, chapters } = this.chargeForm;
        
        if (charge_type === 2) {
          // 整体付费验证
          if (!total_price || isNaN(parseFloat(total_price)) || parseFloat(total_price) < 0) {
            this.$message.error('请输入有效的目录价格');
            return false;
          }
        } else if (charge_type === 3) {
          // 按章节付费验证
          if (!chapters || chapters.length === 0) {
            this.$message.error('请至少设置一个章节');
            return false;
          }
          
          for (let i = 0; i < chapters.length; i++) {
            const chapter = chapters[i];
            if (!chapter.name || !chapter.name.trim()) {
              this.$message.error(`请填写第${i + 1}章节的名称`);
              return false;
            }
            if (!chapter.price || isNaN(parseFloat(chapter.price)) || parseFloat(chapter.price) < 0) {
              this.$message.error(`请填写第${i + 1}章节的有效价格`);
              return false;
            }
          }
        } else if (charge_type === 4) {
          // 首节体验+整体付费验证
          if (!first_lesson_price || isNaN(parseFloat(first_lesson_price)) || parseFloat(first_lesson_price) < 0) {
            this.$message.error('请输入有效的首节体验价格');
            return false;
          }
          if (!total_price || isNaN(parseFloat(total_price)) || parseFloat(total_price) < 0) {
            this.$message.error('请输入有效的整体目录价格');
            return false;
          }
        }
        
        return true;
      },

       stageClick(row){
          this.studymenu_id = row.studymenu_id;
         this.$router.push({
        path: '/plus/course_course/stage/stage',
        query: {
          studymenu_id: this.studymenu_id
        }
      });
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            StudymenuApi.del(
              {
                studymenu_id: row.studymenu_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style scoped>
.max-w400 {
  max-width: 400px;
}

.price-settings {
  margin: 15px 0;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.multi-price {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chapter-pricing {
  margin-top: 10px;
}

.chapter-price-list {
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 10px;
}

.chapter-price-item {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 10px;
}

.chapter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.chapter-title {
  font-weight: bold;
  color: #333;
  font-size: 14px;
}

.chapter-content {
  /* display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px; */
}

.chapter-input {
  width: 100%;
}

.add-chapter-btn {
  margin-top: 8px;
}

.dialog-footer {
  text-align: right;
  margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .chapter-content {
    /* grid-template-columns: 1fr; */
  }
  
  .multi-price {
    flex-direction: column;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/plus/course_course/studymenu/studymenu.vue